import { render, staticRenderFns } from "./StudentPresenceList.vue?vue&type=template&id=6ed20735&"
import script from "./StudentPresenceList.vue?vue&type=script&lang=js&"
export * from "./StudentPresenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports